var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{attrs:{"card":"","pills":"","lazy":""}},[_c('b-tab',{attrs:{"title":_vm.$t('Customers')}},[_c('users')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":_vm.$t('Tariffs')}},[_c('tariffs')],1),_vm._v(" "),_c('b-tab',{attrs:{"title":_vm.$t('Parametrs')}},[_c('settings')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec750ca8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customerPortal/24tv/main.vue
// module id = null
// module chunks = 